import BaseComponent from "@js/components/base_component.jsx";

class EuiLinkReplacementsIndexTable extends BaseComponent {

  render() {
    return ( this.props.table && this.props.table.length > 0 ) ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th width="25" />
            <th className="column-name" width="75">{ t("headings.id") }</th>
            <th className="column-name" width="200">{ t("headings.mailclass_instanceid") }</th>
            <th className="column-name" width="100">{ t("headings.match_type") }</th>
            <th className="column-name">{ t("headings.notes") }</th>
            <th className="column-actions" style={{width: "200px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification
        type={I18n.t("sections.link_replacements")}
        offerNew={ true }
      />
    );
  }

  _renderRows() {
    return this.props.table.map((link_replacement, i) => {
      return (
        <tr key={ i }>
          <td>
            <FaIcon name="chevron-circle-right" />
          </td>
          <td>{ link_replacement.id }</td>
          <td>{
            link_replacement.mailclass && link_replacement.instanceid
            ? `${ link_replacement.mailclass } / ${ link_replacement.instanceid }`
            : link_replacement.mailclass
            ? link_replacement.mailclass
            : <em>All</em>
          }</td>
          <td>
            <TooltipLink
              text={ I18n.t(`link_replacement_match_types.${ link_replacement.match_type }`) }
              tooltip={ this._describeLinkReplacement(link_replacement) }
            />
          </td>
          <td>{
            link_replacement.notes
            ? ( link_replacement.notes.length > 200 ? <span>{link_replacement.notes.substring(0, 200)}&hellip;</span> : link_replacement.notes )
            : <span>&mdash;</span>
          }</td>
          <td className="index-buttons actions">
            {
              link_replacement.id && (
                <div>
                  <ButtonEdit
                    href={ Routes.edit_eui_link_replacement_path(link_replacement.id, { return_to: window.location.href }) }
                    size="small"
                  />
                  <ButtonView
                    href={ Routes.eui_link_replacement_path(link_replacement.id) }
                    size="small"
                  />
                </div>
              )
            }
          </td>
        </tr>
      );
    });
  }

  _describeLinkReplacement(linkReplacement) {
    var desc = "";

    switch ( linkReplacement.match_type ) {
      case "all":
        desc += "All links:";
        break;
      case "exact":
        desc += `Links that exactly match the following:` + "\n" + linkReplacement.match_string;
        break;
      case "regexp":
        desc += `Links that match the following regular expression:` + "\n" + linkReplacement.match_string;
        break;
      case "linkid":
        desc += `Links that contain the data-ga-linkid:` + "\n" + linkReplacement.linkid;
        break;
    }


    if ( linkReplacement.replacement_string ) {
      desc += "\n\n";
      desc += `Will be replaced with:` + "\n" + linkReplacement.replacement_string;
    }

    if ( linkReplacement.expiration_time ) {
      desc += "\n\n";
      desc += `Will expire at:` + "\n" + linkReplacement.expiration_time;
    }

    return desc;
  }

}

export default EuiLinkReplacementsIndexTable;
